export default __webpack_public_path__ + "static/media/loader.461de46b.svg";